import {
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_FAILURE,
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST,
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_SUCCESS,
} from './types/PoolMembershipManagementActionTypes';

export function poolMembershipManagementSaveRequestActionCreator(context, selectedImpcs) {
  return {
    type: POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST,
    payload: {
      appContext: context,
      params: {
        impcCodes: selectedImpcs,
      },
    },
  };
}

export function poolMembershipManagementSaveSuccessActionCreator(data) {
  return {
    type: POOL_MEMBERSHIP_MANAGEMENT_SAVE_SUCCESS,
    payload: data,
  };
}

export function poolMembershipManagementSaveFailureActionCreator(error) {
  return {
    type: POOL_MEMBERSHIP_MANAGEMENT_SAVE_FAILURE,
    payload: error,
    error: true,
  };
}
